import { useMemo } from 'react';
import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { useCurrentRoute } from '@jira/platform__utils-router/src/index.tsx';

// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';
import { isInJsmGlobalSettingsBoundary } from '@jira/platform__banners-jsm-packaging-updates/src/isInJsmGlobalSettingsBoundary.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const useJsmGracePeriodBanner = (): {
	isEnabled: boolean;
} => {
	const currentRoute = useCurrentRoute();
	const { data: project } = useProjectContext();

	const isServiceProject = project?.projectType === SERVICE_DESK_PROJECT;
	const isInJsmBoundary = useMemo(
		() => isInJsmGlobalSettingsBoundary(currentRoute.path) || isServiceProject,
		[isServiceProject, currentRoute.path],
	);

	return useMemo(
		() => ({
			isEnabled: isInJsmBoundary && fg('jsm_gp_announcements_banner'),
		}),
		[isInJsmBoundary],
	);
};
